import React, { useRef, useEffect } from "react";
import { connect } from "react-redux";
import {
  Card,
  Box,
  CardContent,
  CardActions,
  useMediaQuery,
} from "@mui/material";
import SmallModalTemplateHeader from "components/SmallModalTemplateHeader";

function useOutsideAlerter(ref, onCancelAlternatives) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        onCancelAlternatives();
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}

const SmallModalViewTemplate = (props) => {
  const {
    title,
    handleBack,
    children,
    showBackButton,
    footerView,
    onCancelAlternatives = null,
    organizationInfo,
  } = props;
  const matches = useMediaQuery("(max-width:600px)");
  const isHCPTemplate =
    organizationInfo?.type?.toLowerCase() === "h" &&
    organizationInfo?.app?.appCode?.toLowerCase() == "hcp";
  const wrapperRef = useRef(null);
  if (onCancelAlternatives) {
    if (isHCPTemplate) {
      useOutsideAlerter(onCancelAlternatives);
    } else {
      useOutsideAlerter(wrapperRef, onCancelAlternatives);
    }
  }

  console.log("wrapperRef", wrapperRef);

  return (
    <div id="SmallModalViewTemplate" ref={wrapperRef}>
      <Box pt={10} className="small-modal-view">
        <Card className="small-modal-card">
          <Box className="small-modal-bg"></Box>
          {title ? (
            <SmallModalTemplateHeader
              title={title}
              handleBackClick={() => handleBack()}
              showBackButton={showBackButton}
            />
          ) : null}

          <CardContent
            className="small-modal-card-content"
            sx={{
              maxHeight: "650px",
              overflowY: "auto",
              padding: matches ? "40px 20px" : "40px",
            }}
          >
            <Box>{children}</Box>
          </CardContent>
          {footerView ? (
            <CardActions
              sx={{
                justifyContent: "center",
                backgroundColor: "#f0f2f2",
                height: "70px",
                paddingTop: "32px",
              }}
            >
              {footerView}
            </CardActions>
          ) : null}
        </Card>
      </Box>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    organizationInfo: state.organizationInfo.data || {},
  };
};
export default connect(mapStateToProps)(SmallModalViewTemplate);
